import TableComponent from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { columnsConsultant } from "../../Global Functions/columnsAntd";
import { consultantList } from "../../Redux/Actions/consultantAction";
import { listCabService } from "../../Redux/Actions/cabRequestActions";
import { Switch } from "antd";
import { Link } from "react-router-dom";

const ListCabService = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const payload = {
      page: 1,
      limit: 10,
    };
    dispatch(listCabService(payload));
  }, []);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const { cabServiceList } = useSelector((state) => state.cabs);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const cabServiceProviderColumn = [
    {
      title: "Sr no.",
      key: "srno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Organization Name",
      dataIndex: "company_name",
      key: "company_name",
    },
    {
      title: "Country",
      dataIndex: ["country", "country_name"],
      key: "country_name",
    },
    {
      title: "Country Code",
      dataIndex: "country_code",
      key: "country_code",
    },
    {
      title: "Phone",
      dataIndex: "contact_number",
      key: "contact_number",
    },
    {
      title: "State",
      dataIndex: ["state", "state_name"],
      key: "state",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: (text) => (
        <span>{text?.length > 20 ? `${text.slice(0, 20)}...` : text}</span>
      ),
    },
    {
      title: "City",
      dataIndex: ["city", "city_name"],
      key: "city",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Switch checked={status === "active"} />,
    },
    ...(canAdd
      ? [
        {
          title: "Action",
          key: "action",
          render: (text, record) => (
            <Link
              to={`/cabServiceProvider/select/${record._id}`}
              style={{ color: "#0066FF" }}
              state={{
                countryId: record.country?._id,
                serviceProviderId: record._id,
              }}
            >
              Select Cab
            </Link>
          ),
        },
      ]
      : []),
  ];

  return (
    <TableComponent
      h3heading="Cab Service Provider"
      buttonhead2={canAdd ? "Add Service Provider" : null}
      navigateTo2={canAdd ? "/cabServiceProvider/add" : null}
      dataSource={cabServiceList?.data}
      pagination={pagination}
      columns={cabServiceProviderColumn}
    />
  );
};
export default ListCabService;
